export default {
    so: {
        status: {
            new     : 1,
            proceed : 2,
            done    : 3,
            canceled: 4,
        }
    },
    lineColor: [
        'Trắng',
        'Đỏ',
        'Tím',
        'Vàng',
        'Hồng',
        'Cam + xanh',
        'Cam + đỏ',
        'Trắng + XN',
        'Trắng + XD',
        'Trắng + tím',
        'Vàng + xanh',
        'Vàng + đỏ',
        'Vàng + cam',
        'Xanh nhạt',
        'Đỏ XD',
        'Vàng + XD',
        'Ép điện',
        'Vàng + tím',
        'Tím đỏ',
        'Trắng đỏ',
        'Vàng trắng',
        'Cam',
        'Trắng hồng',
        'Đỏ XN',
        'Vàng hồng',
    ],
    bins: [
        'S1',
        'S2',
        'G1',
        'G2',
        'G3',
        'H1',
        'H2',
        'K1',
        'K2',
        'K3',
        'K4',
        'T1',
        'T2',
        'T3',
        'M1',
        'M2',
        'M3',
        'M4',
        'M5',
        'N1',
        'N2',
        'N3',
        'N4',
        'KV tập kết (SP không phù hợp)',
    ],
    customerTypes: [
        {
            id: -1,
            name: 'Đóng container',
        },
        {
            id: -2,
            name: 'Gạo chợ',
        },
        {
            id: 1,
            name: 'Khách lẻ (mua PP)',
        },
        {
            id: 2,
            name: 'Khách lẻ (mua gạo)',
        },
    ],
}